export default {
  methods: {
    $_bankAccount_getBankAccountName(accountName) {
      const parsed = this.$_bankAccount_regex.exec(accountName);
      if (parsed && parsed.length >= 3) {
        return parsed[1];
      }
      return accountName;
    },
    $_bankAccount_getMaskedNumber(accountName) {
      const parsed = this.$_bankAccount_regex.exec(accountName);
      return `${(parsed && parsed[2]) || accountName}`;
    },
    $_bankAccount_getMaskedNumberShort(accountName) {
      const parsed = this.$_bankAccount_regex.exec(accountName);
      if (parsed && parsed[2]) return parsed[2].slice(3, 8);
      return accountName;
    },
    $_bankAccount_getInstitutionId(accountName) {
      if (!accountName) return null;
      const parsed = accountName.match(/ins_\d+$/);
      return parsed && parsed[0];
    },
    $_bankAccount_getClearedOfInsIdText(text) {
      return text.replace(/\sins_\d+/g, '');
    },
  },
  staticData: {
    $_bankAccount_regex: /(.*)\s((\*{4})?\d{4})(\sins_\d+)?$/,
  },
};
